<template>
  <div>
        <div class="col-xs-12 push">
          <div class="col-xs-12 col-sm-6">
            <div class="form-check">
                <input type="checkbox" id="checkbox" v-model="displayDataTable">
                <label for="checkbox">{{ labelTableTop[actualLanguage] }}</label>
            </div>
          </div>


        </div>

        <div v-if="displayDataTable">
              <div class="form-check">
                <input type="checkbox" id="checkboxAvrPow" v-model="displayAvrPowerColumn">
                <label for="checkboxAvrPow">{{ labelTableColAvrPower[actualLanguage] }}  </label>

                <input type="checkbox" id="checkboxPeak" v-model="displayPeakColumn">
                <label for="checkboxPeak">{{ labelTableColPeakPower[actualLanguage] }} </label>

                <input type="checkbox" id="checkboxKwr" v-model="displayKwrColumn">
                <label for="checkboxKwr">{{ labelTableColConsumption[actualLanguage] }}</label>

                <input type="checkbox" id="checkboxCost" v-model="displayCostColumn">
                <label for="checkboxCost">{{ labelTableColCost[actualLanguage] }}</label>


              </div>

              <table class="table remove-margin-b font-s13">
                <thead>
                  <tr>
                    <th>{{ labelTableColTime[actualLanguage] }}</th>
                    <th v-if="displayAvrPowerColumn">{{ labelTableColAvrPower[actualLanguage] }}</th>
                    <th v-if="displayPeakColumn">{{ labelTableColPeakPower[actualLanguage] }}</th>
                    <th v-if="displayKwrColumn">{{ labelTableColConsumption[actualLanguage] }}</th>
                    <th v-if="displayCostColumn">{{ labelTableColCost[actualLanguage] }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="dataLine in this.tableData">
                    <td class="font-w600 text-muted">{{ dataLine.timestamp }}</td>
                    <td v-if="displayAvrPowerColumn" class="font-w600 text-success " >{{ dataLine.avrPower | round }}</td>
                    <td v-if="displayPeakColumn" class="font-w600 text-success " >{{ dataLine.peak | round }}</td>
                    <td v-if="displayKwrColumn" class="font-w600 text-success " >{{ dataLine.kwr | round }}</td>
                    <td v-if="displayCostColumn" class="font-w600 text-success " >{{ dataLine.cost | round }}</td>
                  </tr>
                </tbody>
              </table>
              
        </div>
  </div>
</template>

<script>

import _ from 'underscore'

export default {
  props: ['tableData'],
  data() {
    return {
      displayDataTable : false,
      displayAvrPowerColumn : true,
      displayPeakColumn : true,
      displayKwrColumn : true,
      displayCostColumn : true,
      displayTemperatureColumn : false,
      displayHumidityColumn : false,
      displayCloudColumn : false,
      displayWindColumn : false,
      
      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},
      labelTableColTime: {FR: 'Temps', EN: 'Time'},
      labelTableColAvrPower: {FR: 'Puissance moyenne', EN: 'Average power'},
      labelTableColPeakPower: {FR: 'Appel de puissance', EN: 'Peak power'},
      labelTableColConsumption: {FR: 'Consommation(kWh)', EN: 'Consumption(kWh)'},
      labelTableColCost: {FR: 'Consommation($)', EN: 'Consumption($)'},
      labelTableColTemperature: {FR: 'Température(C)', EN: 'Temperature(C)'},
      labelTableColHumidity: {FR: 'Humidité(%)', EN: 'Humidity(%)'},
      labelTableColCloud: {FR: 'Ennuagement(%)', EN: 'Cloudy(%)'},
      labelTableColWind: {FR: 'Vent(km/h)', EN: 'Wind(km/h)'},

      labelButtonDownloadData: {FR: 'Télécharger les données', EN: 'Download data'},
    }
  },

  methods: {
  
  },
  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// DataTable.vue?28a748e4